import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  className?: string;
  fullWidth?: boolean;
  showIcon?: boolean;
  scrollToPurchase?: boolean;
}
export function CTAButton({
  text,
  className = '',
  fullWidth = false,
  showIcon = true,
  scrollToPurchase = false
}: CTAButtonProps) {
  const checkoutUrl = 'https://checkout13.edulabs.online/cart/44682428743816:1';
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (scrollToPurchase) {
      e.preventDefault();
      const purchaseSection = document.getElementById('purchase-section');
      if (purchaseSection) {
        purchaseSection.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  };
  return <a href={checkoutUrl} onClick={handleClick} className={`
        inline-flex items-center justify-center
        bg-green-600 hover:bg-green-700 text-white font-bold
        py-5 px-10 rounded-md shadow-lg hover:shadow-xl
        transition-all duration-200 text-lg md:text-xl uppercase tracking-wide
        ${fullWidth ? 'w-full' : 'w-auto'}
        ${className}
      `} data-id="element-1">
      {text}
      {showIcon && <ArrowRight className="ml-2 h-6 w-6" data-id="element-2" />}
    </a>;
}